import React from 'react'
import logoCentro from "../../media/icons/logoCentro.png"
import { useNavigate } from 'react-router-dom'

function Dashboard({status}) {




  //NAVIGATE
  const navigate =useNavigate();
  function goTo(route){
    navigate(route)
  }

  return (
    <div >

      <div className="greenhouseBg p-5 col-12">
        <div className="col-12">
            <h1 className="text-white tittle">ESTUDIANTES FORESTALES</h1>
              <p className="fs-4 text-white">La aplicación del Centro de Estudiantes Diego Rodriguez Laguens.</p>
            {
              status===true?
              <button className="yellowBtn" onClick={() => goTo("/login")}>Iniciar Sesión</button>
              :
              <span></span>
            }
        </div>
      </div>

      <div className="d-flex justify-content-center align-items-center py-3" >
         <img className="col-8 p-3" src={logoCentro} alt="logoCentro"/>
      </div>


      <div className="d-flex flex-row justify-content-between flex-wrap gap-4 ">

          <div className='col-12 d-flex flex-row flex-wrap'>
                <div className="col-12 col-md-8 pe-md-2 d-flex clickOver" onClick={() => goTo("/biblioteca")}>
                      <div className=" bg-white p-5 col-12 d-flex align-items-center">
                        <div className="d-flex flex-column ">
                          
                          <h1 className="mainText militaryBackground text-white rounded-1 py-3 px-5">BIBLIOTECA</h1>
                            <p className="fs-4 mt-2">Conoce todos los libros que están disponibles en la biblioteca de la sala de estudio.</p>
                        </div>
                      </div>
                </div>
                <div className="col-12 col-md-4 ps-md-2 clickOver p-2" onClick={() => goTo("/fotocopiadora")}>
                      <div className="creamBackground p-5 col-12 text-end rounded-2">
                        <div className='d-flex flex-column  pt-2'>
                            <h1 className="fw-bold">FOTOCOPIADORA</h1>
                            <p className="fs-4">Impresiones a color, blanco negro, al mejor precio y gestionada por estudiantes.</p>
                        </div> 
                      </div>
                </div>

                <div className="col-12 col-md-8 pe-md-2 d-flex clickOver" onClick={() => goTo("/apuntes")}>
                      <div className=" bg-white p-5 col-12 d-flex align-items-center">
                        <div className="d-flex flex-column ">
                          
                          <h1 className="mainText regularText militaryBackground text-white rounded-2 py-3 px-5">APUNTES</h1>
                            <p className="fs-4 mt-2">Comparte y descarga apuntes realizados por otros estudiantes.</p>
                        </div>
                      </div>
                </div>
                <div className="col-12 col-md-4 ps-md-2 clickOver p-2" onClick={() => goTo("/informacion")}>
                      <div className="creamBackground  p-5 col-12 text-end rounded-2">
                        <div className='d-flex flex-column  pt-2'>
                            <h1 className="fw-bold">DIEGO RODRIGUEZ LAGUENS</h1>
                            <p className="fs-4">Conoce su historia y por qué el Centro lleva su nombre...</p>
                        </div> 
                      </div>
                </div>
          </div>

      </div>

     
    </div>
  )
}

export default Dashboard